<template>
  <v-hover>
    <template v-slot:default="{ hover }">
      <v-card
        max-width="444"
        :class="ClassAd || 'mx-auto'"
        @click="$emit('click', this)"
      >
        <v-img :src="value.Image" min-height="100%" min-width="100%">
          <v-fade-transition>
            <v-overlay absolute :value="active || hover" :opacity="0.7">
              <v-layout class="d-flex flex-column">
                <div class="mb-auto">
                  <v-list-item>
                    <v-list-item-avatar color="grey"></v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title class="headline">
                        <p :title="value.Title">
                          {{ value.Title.slice(0, 20) }}
                        </p>
                      </v-list-item-title>
                      <v-list-item-subtitle
                        >por {{ value.Author }}</v-list-item-subtitle
                      >
                    </v-list-item-content>
                  </v-list-item>
                </div>

                <v-card-text>{{ value.Summary }}</v-card-text>

                <v-card-actions class="align-self-end">
                  <v-btn text>Continuar a leitura</v-btn>
                  <v-spacer></v-spacer>
                  <v-btn icon>
                    <v-icon>mdi-share-variant</v-icon>
                  </v-btn>
                </v-card-actions>
              </v-layout>
            </v-overlay>
          </v-fade-transition>
        </v-img>

        <!--      
    <template v-if="!active">
      <v-img :src="value.Image" min-height="100%" min-width="100%"></v-img>
      <v-list-item style="opacity:1" dark>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{ value.Title }}</v-list-item-title>
          <v-list-item-subtitle>por {{ value.Author }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </template>
    <template v-else>
      <v-list-item>
        <v-list-item-avatar color="grey"></v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="headline">{{ value.Title }}</v-list-item-title>
          <v-list-item-subtitle>por {{ value.Author }}</v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>

      <v-img :src="value.Image" height="194"></v-img>

      <v-card-text>{{ value.Summary }}</v-card-text>

      <v-card-actions>
        <v-btn text>Read</v-btn>
        <v-btn text>Bookmark</v-btn>
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>mdi-heart</v-icon>
        </v-btn>
        <v-btn icon>
          <v-icon>mdi-share-variant</v-icon>
        </v-btn>
      </v-card-actions>
    </template>
        -->
      </v-card>
    </template>
  </v-hover>
</template>
<script>
export default {
  name: "uBlogPost",
  props: ["value", "ClassAd", "active", "dark"],
  components: {},
  created() {
    console.log("value", this.post);
  }
};
</script>
